import { AuthApi as Api } from "./auth.api";
import LocalStorageKeys from "../../../../data/localStorageKeys";

export class AuthFacade {
    static async loginWithDni(dni) {
        const sbClientData = await Api.logInWithDni(dni);

        let clientData = await Api.getClientData(dni);

        if (!clientData) {
            const newClient = {
                dni: sbClientData.user.dni,
                email: sbClientData.user.mail,
                nombres: sbClientData.user.nombre,
            };

            clientData = await Api.createClient(newClient);
        }

        await this._saveClientData(clientData, sbClientData);

        return sbClientData;
    }

    static _saveClientData(cbData, sbData) {
        localStorage.setItem(LocalStorageKeys.cliente.idUser, cbData.id);
        localStorage.setItem(LocalStorageKeys.cliente.dni, cbData.dni);
        localStorage.setItem(LocalStorageKeys.cliente.user, cbData.nombres);

        localStorage.setItem(LocalStorageKeys.cliente.logoCompania, sbData.user.logoCompania);

        localStorage.setItem(LocalStorageKeys.cliente.userSb, sbData.user.id);
        localStorage.setItem(LocalStorageKeys.cliente.token, sbData.token);
    }
}